import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes.js'

Vue.use(VueRouter)

const enrutador = new VueRouter({
  routes: routes,
  mode: "history",
  linkExactActiveClass: "is-active" // active class for *exact* links.
});

enrutador.beforeEach((to, from, next) => {
  let isAuthenticated = window.localStorage.getItem("token") || undefined;
  if (to.name !== "Login" && !isAuthenticated) {
    next({ name: "Login" });
  } else {
    console.log('next')
    next();
  }
});

export default enrutador;